module.exports = __webpack_public_path__ + "img/pn.391128d8.svg";